import { diff } from 'json-diff-ts';

export const isObjectsEqual = (
  a: Record<string, unknown> | null | undefined,
  b: Record<string, unknown> | null | undefined,
) => {
  return compare(a, b);
};

export const getObjectDiff = (
  a?: Record<string, string>,
  b?: Record<string, string>,
): Record<string, string> | null => {
  if (!a || !b) {
    return null;
  }

  const diffArray = diff(a, b);
  return diffArray.reduce(
    (acc, item) => {
      acc[item.key] = item.value;
      return acc;
    },
    {} as Record<string, string>,
  );
};

function compare(a: unknown, b: unknown): boolean {
  if (typeof a !== typeof b) {
    return false;
  }

  if (typeof a !== 'object' || typeof b !== 'object') {
    return a === b;
  }

  if (Array.isArray(a) !== Array.isArray(b)) {
    return false;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }

    return a.sort().every((value, index) => compare(value, b.sort()[index]));
  }

  if (a === null || b === null) {
    return a === b;
  }

  const keysA = Object.keys(a).sort();
  const keysB = Object.keys(b).sort();

  if (keysA.length !== keysB.length) {
    return false;
  }

  const hasDiff = diff(a, b);
  return hasDiff.length ? false : true;
}
